const PATH = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CREATE_PASSWORD: '/create-password',
  CONNECT: '/connect',
  HOME: '/',
  INTEGRATION: '/integration',
  COMPANY: '/company',
  CALL: '/call',
  CONTACT: '/contact',
  STRATEGIES: '/sequences',
  STRATEGY_DETAIL: '/sequences/:id/:tab?',
  STRATEGY_NEW: '/sequences/new',
  TEMPLATES: '/template',
  TEMPLATE_UPSERT_NEW: '/template/upsert',
  TEMPLATE_UPSERT: '/template/upsert/:id?',
  TASK: '/task',
  TASKS_MAIN_PAGE: '/tasks',
  ONBOARDING: '/onboarding',
  MIGRATION: '/migrating',
  COMPLETE: '/complete',
  SUBSCRIPTION_PAGE: '/subscription-page',
  EXPIRED: '/expired',
  SIGN_UP: '/signup',
  SUCCESS_SIGN_UP: '/success-signup',
  THANK_YOU: '/thank-you',
  CONNECTION_HUB: '/api/notificationshub/nots',
  REGISTER: '/register',
  FREE_TRIAL: '/crnfrtrl99',
  OPT_OUT: '/opt-out',
  FIND_NEW: '/find-new',
  LISTS: '/lists',
  INBOX: '/inbox',
  DEALS: '/deals',
  DEALS_DETAIL: '/deals/:dealId',
  AGENTS: '/agents',
  AGENT_NEW: '/agents/new',
  AGENT_EXECUTION: '/agents/:id',
  AGENT_EDIT: '/agents/:id/edit',
  AGENT_ACTIVITY_LOG: '/agents/:id/activity-log',
  CHARTS: '/charts',
  CHARTS_NEW: '/charts-new',
  REPORTS: '/reports',
  KNOWLEDGE: '/knowledge',
  MFA: '/mfa',
  MFA_SETUP: '/mfa-setup',
  OAUTH_CONSENT: '/oauth/consent',
  OAUTH_SLACK: '/oauth/slack',
  OAUTH_SLACK_USER: '/oauth/slack/user',
  WARMY_CONNECTED: '/warmy/connected',
  WARMY_CONNECTION_FAILED: '/warmy/connection-failed',
  ACCESS_DENIED: '/403',
  SETTINGS: {
    MAIN: '/settings',
    SECURITY: '/settings/security',
    INTEGRATIONS: {
      MAIN: '/settings/integrations',
      MAILBOX: '/settings/integrations/mailbox',
      WARMUP_HUB: '/settings/integrations/mailbox/warmup-hub',
      WARMUP_MAILBOX: '/settings/integrations/mailbox/warmup-hub/mailbox',
      BROWSER_EXTENSION: '/settings/integrations/browser-extension',
      CALL: '/settings/integrations/call',
      API: '/settings/integrations/api',
      WEBHOOK_NEW: '/settings/integrations/api/webhook/new',
      WEBHOOK_EDIT: '/settings/integrations/api/webhook/:id',
      SLACK_NOTIFICATIONS: '/settings/integrations/api/slack/notifications',
      CALENDAR: '/settings/integrations/calendar',
    },
    LEAD_SCORE: '/settings/score',
    IMPORT_DATA: '/settings/import-data',
    USERS: '/settings/users',
    SUBSCRIPTION: '/settings/billing',
    ADD_ONS: '/settings/add-ons',
    ENRICHMENT_PROVIDERS: '/settings/enrichment-providers',
    TEMPLATE_VARIABLES: '/settings/template-variables',
    TAG: '/settings/tag-management',
    FIELDS: '/settings/fields-management',
    AUTOMATIONS: '/settings/automations',
    STATUS: '/settings/status-management',
    PIPELINES: '/settings/pipelines-management',
    WEBSITE_TRACKING: '/settings/website-tracking',
  },
};

//This is the list of pathnames from which we do not want to redirect to login if not authenticated user is there
export const noRedirectToLoginPathnames = [
  PATH.REGISTER,
  PATH.FREE_TRIAL,
  PATH.RESET_PASSWORD,
  PATH.FORGOT_PASSWORD,
  PATH.CREATE_PASSWORD,
  PATH.SIGN_UP,
  PATH.OPT_OUT,
  PATH.LOGIN,
  PATH.SUCCESS_SIGN_UP,
  PATH.MFA,
  PATH.MFA_SETUP,
  PATH.OAUTH_CONSENT,
];

export default PATH;
